module.exports = {
      id: "vikatan-play-logo-red-usage",
      viewBox: "0 0 536.066 789.439",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#vikatan-play-logo-red",
      toString: function () {
        return this.url;
      }
    }